import APICall from "../utils/APICall"

export default class BusinessServices {
  
   // /api/NewAccount/admin/accounts/business-accounts?page=1&pageLimit=10
    static listBusinessAccount = async (page, pageLimit, search, from, to, businessType,  businessDocumentUploadStatus) => {
        let url = `/api/NewAccount/admin/accounts/business-accounts?page=${page}&pageLimit=${pageLimit}`
        if(search) url = url + `&search=${search}`
        if(businessType) url = url + `&businessType=${businessType}`
        if(businessDocumentUploadStatus) url = url + `&businessType=${businessType}&businessDocumentUploadStatus=${businessDocumentUploadStatus}`
        if(to && from) url = url + `&from=${from}&to=${to}`
        return await APICall(url, "GET")
    }
    static viewBusinessAccount = async (BusinessOwnerUserName) => {
        return await APICall(`/api/NewAccount/admin/accounts/business-account?BusinessOwnerUserName=${BusinessOwnerUserName}`, "GET")
    }
    static exportBusinessAccount = async (search, from, to, businessType, businessDocumentUploadStatus) => {
        return await APICall(`/api/NewAccount/admin/accounts/export/business-accounts?search=${search}&from=${from}&to=${to}&businessType=${businessType}&businessDocumentUploadStatus=${businessDocumentUploadStatus}`, "GET")
    }
    static actionBusinessAccount = async (payload) => {
        return await APICall(`/api/NewAccount/admin/accounts/business-account/update`, "POST", payload);
    }
    static listBusinessSector = async () => {
        return await APICall(`/api/NewAccount/admin/accounts/business-sector`, "GET");
    }
    static listBusinesClass = async () => {
        return await APICall(`/api/NewAccount/admin/accounts/business-account-classes`, "GET")
    }
}